// exchange — call api-gateway → auth-api /v1/auth/liff/exchange
import { apiFetch } from "../lib/api-client.js";
import type { LiffPageKind, LiffSession } from "./types.js";

export class LiffExchangeError extends Error {
  constructor(message: string, public readonly status: number, public readonly body: unknown) {
    super(message);
    this.name = "LiffExchangeError";
  }
}

export async function exchangeLiffSession(idToken: string, liffApp: LiffPageKind, correlationId?: string): Promise<LiffSession> {
  const r = await apiFetch("/v1/auth/liff/exchange", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ id_token: idToken, liff_app: liffApp }),
  }, { correlationId });
  let body: unknown = null;
  try { body = await r.json(); } catch {}
  if (!r.ok) {
    // Prefer body.message (real exception text from auth-api onError, e.g.
    // "D1_ERROR: no such column: …") over body.error (which is the
    // JS Error.name and is often just "Error" for raw throws). Fall back
    // to body.error when message is absent (e.g. structured 4xx like
    // { error: "id_token_invalid" }), then to plain HTTP status.
    const b = body as { error?: string; message?: string } | null;
    const msg = b?.message ?? b?.error ?? `HTTP ${r.status}`;
    throw new LiffExchangeError(msg, r.status, body);
  }
  return body as LiffSession;
}
